import {React, FC} from 'external/react'

type GroupLabelProps = {
    groups: any[],
    index: number,
    id: string, name: string
}

const GroupLabel: FC<GroupLabelProps> = (props) => {
  const {id, name, index, groups} = props
  const isLast = index == groups.length - 1
  const separator = isLast ? '' : ','
  return (<label key={id} className={`group-label${index == 0 ? ' first' : ''}`}>{name}{separator}</label>)
}

export default GroupLabel